<template lang="pug">
  .sidebar(:class="{ open: openSidebar }")
    .search
      .search-menu
        .search-title
          span 絞り込む
        .search-row
          span.search-label 開業基準日
          span.search-label-sub 開始
          date-picker(v-model="searchDateFrom" format="YYYY-MM-DD" value-type="format" :editable="false" :disabled-date="disabledRange")
          span.search-label-sub 終了
          date-picker(v-model="searchDateTo" format="YYYY-MM-DD" value-type="format" :editable="false" :disabled-date="disabledRange")
        .search-row
          span.search-label ジャンル
          MultipleSelect(v-model="genreId" :options="vSelectGenre")
        .search-row
          span.search-label エリア
          .select-choice-field
            .select-choice(
              @click="toggleCompanyCityModal"
              :class="{ active: openPrefectureCityModal }")
              ul.select-choice-selected
                li(v-for="option in cityCd")
                  div
                    | {{ option.label }}
                    a.select-choice-delete(@click="removeCityCd($event, option.value)") 削除
              PrefectureCityModal(
                :prefectures="this.$store.state.master.startingBusinessPrefectures"
                :openPrefectureCityModal="openPrefectureCityModal"
                :selectedCityCd="cityCd"
                @setPrefectureCities="setCityCd"
                @hide="hidePrefectureCityModal")
        .search-row
          span.search-label キーワードその他
          label.text
            input(
              type="text"
              v-model="keyword"
              placeholder="例）店舗名など"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
        .search-row
          label.checkbox
            input(type="checkbox"
              v-model="excludedNoCompanyTel"
              true-value="true"
              false-value="false")
            span 電話番号なしを省く

      .search-button
        input.button-main(
          type="button"
          @click="search"
          value="検索する"
          :disabled="locked")
        span
          a(@click="clear") クリア
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'
  import 'vue2-datepicker/locale/ja'
  import {
    DefaultExcludedNoCompanyTel,
    DefaultSearchDateFrom,
    DefaultSearchStartingBusinessQuery,
  } from '../../constants'
  import mapGetSet from '../../libs/map-get-set'
  import searchStartingBusiness from '../../store/modules/searchStartingBusiness'
  import MultipleSelect from '../parts/MultipleSelect'
  import PrefectureCityModal from '../parts/PrefectureCityModal'

  export default {
    components: { MultipleSelect, PrefectureCityModal, DatePicker },
    props: ['openSidebar'],
    data () {
      const {
        searchDateFrom = DefaultSearchDateFrom,
        searchDateTo = '',
        genreId = '',
        industryMajorClassCd = '',
        excludedNoCompanyTel = DefaultExcludedNoCompanyTel,
        cityCd = '',
        keyword = '',
      } = this.$route.query

      // query parameter initialization
      const master = this.$store.state.master
      this.searchDateFrom = searchDateFrom
      this.searchDateTo = searchDateTo
      this.genreId = this.toObjects(genreId, master.genre)
      this.industryMajorClassCd = this.toObjects(industryMajorClassCd, master.startingBusinessIndustryMajorClasses)
      this.excludedNoCompanyTel = excludedNoCompanyTel
      this.cityCd = this.toObjects(cityCd, master.cities)
      this.keyword = keyword

      return {
        openPrefectureCityModal: false,
        keyDownCode: '',
      }
    },
    computed: {
      ...mapGetters({
        apiQuery: 'searchStartingBusiness/apiQuery',
        locked: 'common/isGlobalLocked',
      }),
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.searchStartingBusiness.query[k],
        set: ($vm, $s, k, v) => $s.commit(`searchStartingBusiness/${k}`, v),
        keys: Object.keys(searchStartingBusiness.state.query),
      }),
      vSelectGenre () {
        return this.$store.state.master.genre.map(m => ({ label: m.name, value: m.id }))
      },
    },
    watch: {
      $route () {
        Object.assign(this.$data, this.$options.data.apply(this))
      },
    },
    methods: {
      ...mapMutations('startingBusiness', ['uncheckAll']),
      disabledRange (date) {
         return date < Date.parse(DefaultSearchDateFrom.replace(/-/g, '/')) || date > new Date()
      },
      clear () {
        const { name } = this.$route
        this.uncheckAll()
        this.$emit('toggleSidebar')
        const query = {
          ...DefaultSearchStartingBusinessQuery,
          perPage: String(this.$store.state.user.detail.jobs_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        this.$router.push({ name, query })
      },
      hidePrefectureCityModal () {
        this.openPrefectureCityModal = false
      },
      async keydownCondition (e) {
        this.keyDownCode = e.which
      },
      async keyupCondition (e) {
        // Enter押下時に検索する。keyDownCode持ってるのは日本語変換のEnterを無視するため
        if (e.which === 13 && e.which === this.keyDownCode) {
          this.search()
        }
      },
      removeCityCd (e, cityCd) {
        e.stopPropagation()
        this.cityCd = this.cityCd.filter(j => j.value !== cityCd)
      },
      async search () {
        const { name, query } = this.$route
        this.$store.commit('common/lockGlobal')
        this.uncheckAll()
        try {
          this.$router.push({
            name,
            query: {
              ...this.apiQuery,
              perPage: query.perPage,
              page: '1',
              _t: Date.now(),
            },
          })
        } finally {
          this.$emit('toggleSidebar')
          this.$store.commit('common/unlockGlobal')
        }
      },
      toObjects (ids, masterData) {
        if (!ids) {
          return []
        }

        const isNumber = typeof masterData[0].code === 'number'
        return ids.split(',').reduce((list, id) => {
          const data = isNumber ?
            masterData.find(d => d.code === Number(id)) :
            masterData.find(d => d.code === id)
          if (data) {
            list.push({ label: data.name, value: data.code })
          }
          return list
        }, [])
      },
      async setCityCd (cityCd) {
        this.openPrefectureCityModal = false
        this.cityCd = cityCd
      },
      toggleCompanyCityModal (e) {
        e.stopPropagation()
        this.openPrefectureCityModal = !this.openPrefectureCityModal
      },
    },
  }
</script>

<style scoped lang="css">
.mx-datepicker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessSidebar.vue